"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports["int"] = exports.setButtonLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _index = require("../config/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var setButtonLabel = function setButtonLabel(type, value) {
  var result = '';

  switch (type) {
    case 'prevPageButton':
      result = _react["default"].createElement(_spauiIcon["default"], {
        type: "arrow-left"
      });
      break;

    case 'nextPageButton':
      result = _react["default"].createElement(_spauiIcon["default"], {
        type: "arrow-right"
      });
      break;

    case 'totalPageButton':
      result = _index.defaultLocale.totalPageButton.replace('{value}', value);
      break;

    case 'ellipsisButton':
      result = '...';
      break;

    default:
      result = value;
      break;
  }

  return result;
};

exports.setButtonLabel = setButtonLabel;

var _int = function _int() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return parseInt(value, 10) || defaultValue;
};

exports["int"] = _int;
var _default = {
  setButtonLabel: setButtonLabel,
  "int": _int
};
exports["default"] = _default;